const TICKET_TYPES = ['RTE', 'RTEDR'];

export const supportsTaxStory = (ticketType) => {
    return TICKET_TYPES.includes(ticketType);
};

export const supportsPOM = (ticketType) => {
    return TICKET_TYPES.includes(ticketType);
};
